export const TestIds = {
  buttonContent: 'buttonContent',
  buttonLabel: 'stylablebutton-label',
};

export const TRANSITION_DURATION = 400;

export const SEMANTIC_CLASS_NAMES = {
  root: 'button',
  buttonLabel: 'button__label',
  buttonIcon: 'button__icon',
} as const;

export const DisplayNames = {
  root: {
    elementDisplayName: 'Button',
    data: {
      disabled: 'Disabled',
    },
    cssProperties: {
      gap: 'Space between text and icon',
    },
    cssCustomProperties: {
      'content-horizontal-alignment': 'Alignment',
      'icon-position': 'Icon position',
    },
    presets: {
      baseButton: 'Base Button',
    },
    iconPosition: {
      beforeText: 'Before text',
      afterText: 'After text',
      belowText: 'Below text',
      aboveText: 'Above text',
    },
  },
  label: {
    elementDisplayName: 'Text',
    cssProperties: {
      font: 'Typography',
    },
    cssCustomProperties: {},
  },
  data: {
    iconCollapsed: 'Display icon',
  },
};
